import React from 'react';
import {DrawerButtonTitle} from '../Common';
import {HeaderLayout} from '../../components';

function NormalizationHeader() {
  return (
    <HeaderLayout>
      <HeaderLayout.Left>
        <DrawerButtonTitle title="Concentration Normalization" drawerButtonVisible={false} />
      </HeaderLayout.Left>
    </HeaderLayout>
  );
}

export default NormalizationHeader;
